<template>
        <div class="uk-container uk-container-large uk-margin-small-top uk-text-center">
            <form class="">
                <div class="uk-form-controls uk-margin">
                    <input class="uk-input uk-width-1-2@l uk-width-1-1@m" type="text" v-model="email" placeholder="Email">
                    <button class="uk-button uk-button-primary" type="button" @click="registerEmail">登録</button>
                </div>
                <div class="uk-width-1-2@l uk-text-left uk-text-small uk-margin-auto">
                <ul>
                    <li>写真をアップロードする時は，最初にメールアドレスを登録してください．</li>
                    <li>既に登録済みの場合は，送信されたメールに書かれたアップロード用URLをクリックしてください．</li>
                </ul>
                </div>
            </form>
        </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs'
export default {
    name: 'app',
    components: {
    },
    props: {
    },
    data: function () {
        return {
            email: '',
        }
    },
    methods: {
        registerEmail: function () {
            this.$axios.post(
                this.$config.common.apiPath + '/register/',
                qs.stringify({'email': this.email})
            ).then( response => {
                var res = response.data
                if (res.status === 'NG') {
                    this.$notify.error({
                      title: 'Error',
                      message: res.message,
                    })
                } else {
                    this.$notify({
                      title: 'Success',
                      message: res.message,
                      type: 'success'
                    })
                }
            }).catch( function (error) {
                console.log(error)
            })
        },
    },
    mounted () {
    // this.$uikit.notification('Hello world.');
    }
}
</script>

<style>
</style>
